module.exports = __webpack_public_path__ + "img/code_b.c84a2d34.png";